// @ts-nocheck
/* eslint-disable padding-line-between-statements, import/order */



/* eslint-disable react/jsx-newline */




import React from 'react';

import { useIntl } from 'react-intl';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import { NotAuthorized } from 'app/components/not-authorized';
import { PageNotFound } from 'app/components/page-not-found';
import { SystemHeader, SystemIcon } from 'app/components/shared/system-header';
import { Organizations } from 'app/configuration/organizations';
import { FareMediaIssuers } from 'app/configuration/fare-media-issuers';
import { FareMediaIssuerOrganizations } from 'app/configuration/fare-media-issuer-organizations';
import { FareMediaTypes } from 'app/configuration/fare-media-types';

import { trimTrailingSlash, useTypedSelector } from 'helpers';
import {
  canViewFareMediaIssuers,
  canViewFareMediaIssuersOrganisations,
  canViewFareMediaTypes,
  hasReadAccessToMasterConfigSubSystem,
} from 'selectors';

const MasterConfig: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const intl = useIntl();

  const canViewOrganizations = useTypedSelector(state =>
    hasReadAccessToMasterConfigSubSystem(state, 'Organizations')
  );

  // Fare Media reference data — Express API, one master_configuration
  // sub-system each (see BACKEND/db/seeds/seedConfigurationPermissions.js).
  const canViewIssuers = useTypedSelector(canViewFareMediaIssuers);
  const canViewIssuerOrganizations = useTypedSelector(
    canViewFareMediaIssuersOrganisations
  );
  const canViewTypes = useTypedSelector(canViewFareMediaTypes);

  /*
   * Land on the first screen this admin may actually open.
   *
   * The module gate (canReadMasterConfig) now passes on ANY one of the four
   * sub-systems, so an admin granted only Fare Media Types would previously
   * have been redirected straight into an Organizations NotAuthorized page.
   */
  const landingCandidates: [boolean, string][] = [
    [canViewOrganizations, 'organizations'],
    [canViewIssuers, 'fare-media-issuers'],
    [canViewIssuerOrganizations, 'fare-media-issuer-organizations'],
    [canViewTypes, 'fare-media-types'],
  ];
  // Falls back to organizations, which then renders NotAuthorized — the same
  // behaviour as before, for an admin who reached here with no sub-system.
  const landingSegment =
    landingCandidates.find(([allowed]) => allowed)?.[1] || 'organizations';
  const landingPath = `${baseURL}/${landingSegment}`;

  return (
    <>
      <SystemHeader
        headerTitle={intl.formatMessage({ id: 'configuration' })}
        headerIcon={SystemIcon.Configurations}
      />

      <Switch>
        <Redirect from={baseURL} exact to={landingPath} />

        <Route path={`${baseURL}/organizations`}>
          {canViewOrganizations ? <Organizations /> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/fare-media-issuers`}>
          {canViewIssuers ? <FareMediaIssuers /> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/fare-media-issuer-organizations`}>
          {canViewIssuerOrganizations ? (
            <FareMediaIssuerOrganizations />
          ) : (
            <NotAuthorized />
          )}
        </Route>

        <Route path={`${baseURL}/fare-media-types`}>
          {canViewTypes ? <FareMediaTypes /> : <NotAuthorized />}
        </Route>

        <Route path="/">
          <PageNotFound />
        </Route>
      </Switch>
    </>
  );
};

export { MasterConfig };
